import React, { useContext } from 'react'
import styled from 'styled-components'

import CornerControls from './common/CornerControls'
import DetailCardLayout from './common/DetailCardLayout'
import ItemTitle from './common/ItemTitle'
import { DetailItemCardVariant } from './common/types'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TripContext from 'tripPlanner/contexts/TripContext'
import { NoteItem } from 'tripPlanner/types/tripItem'
import LineEditAltIcon from 'components/Luxkit/Icons/line/LineEditAltIcon'
import TripItemInlineNoteEdit from '../ItemCard/TripItemInlineNoteEdit'
import { TripDocumentsContext } from 'tripPlanner/contexts/TripDocumentsContext'
import AttachedDocument from '../Documents/AttachedDocument'
import LinePaperclipIcon from 'components/Luxkit/Icons/line/LinePaperclipIcon'
import AssistChip from 'components/Luxkit/Chips/AssistChip'

const NoteContainer = styled.div`
  clear: both; /* Make sure the timeline sits below the corner buttons */
`

interface Props {
  item: NoteItem
  variant: DetailItemCardVariant
  tripNameLabel?: React.ReactNode
}

function DetailNoteCard({ item, variant, tripNameLabel }: Props) {
  const tripContext = useContext(TripContext)
  const canEdit = tripContext?.permissions.canEdit ?? false

  const documentContext = useContext(TripDocumentsContext)
  const attachedDocuments =
    documentContext?.documentsResult?.attachedFiles[item.id] ?? []

  const hasNoAttachments = !!documentContext?.documentsResult && attachedDocuments.length === 0

  return (
    <DetailCardLayout>
      <DetailCardLayout.Image></DetailCardLayout.Image>
      <DetailCardLayout.Content>
        {canEdit && <CornerControls item={item} variant={variant} />}
        <VerticalSpacer gap={8}>
          <ItemTitle icon={LineEditAltIcon}>{item.title?.trim() || 'Note'}</ItemTitle>
          {tripNameLabel}
          <NoteContainer>
            {variant !== 'drawer' && <TripItemInlineNoteEdit item={item} inputAlwaysVisible deleteItemOnClear={hasNoAttachments} />}
          </NoteContainer>
          {attachedDocuments.map((document) => (
            <AttachedDocument key={document.filename} document={document} />
          ))}
          {documentContext && canEdit && (
            <AssistChip
              size="small"
              onClick={() => documentContext.onRequestAddDocument(item.id)}
              variant="filled"
              startIcon={<LinePaperclipIcon />}
            >
              Attach document
            </AssistChip>
          )}
        </VerticalSpacer>
      </DetailCardLayout.Content>
    </DetailCardLayout>
  )
}

export default DetailNoteCard
